/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useData } from "../data/useData";
import { useChart } from "../transformers/useChart";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { Table, TableProps } from "../../../components/Table";
import { ComponentContextReadyState } from "@sa/rep-core";
import { useExport, useSubscriptionProviderContext } from "../../../shared";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const olapData = useHookSubscribe(null, context.olapData);
  const comments = useHookSubscribe([], context.comments$);
  const orderedIds = useHookSubscribe([], context.orderedIds$);
  const data = useData(olapData);
  const tableData = useChart(data, orderedIds);
  const table = React.useMemo(() => (tableData ? <Table {...tableData} /> : null), [tableData]);
  const source = useHookSubscribe(null, context.sources$);
  const [fragmentChil, setFragmentChild] = React.useState<HTMLDivElement | null>(null);

  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);
  const legend = React.useMemo(
    () => (
      <>
        <Table
          columns={[
            { headerName: "", field: "fullnegative", cellStyle: { color: "white", backgroundColor: "#ef5350", textAlign: "center" } },
            { headerName: "", field: "negative", cellStyle: { backgroundColor: "#ff8a65", textAlign: "center" } },
            { headerName: "", field: "normal", cellStyle: { textAlign: "center" } },
            { headerName: "", field: "positive", cellStyle: { backgroundColor: "#a5d6a7", textAlign: "center" } },
            { headerName: "", field: "fullpositive", cellStyle: { color: "white", backgroundColor: "#66bb6a", textAlign: "center" } },
          ].reverse()}
          rows={[
            {
              fullnegative: "< -5%",
              negative: "-5% – -1%",
              normal: "-1% – +1%",
              positive: "+1% – +5%",
              fullpositive: "> +5%",
            },
          ]}
          options={{
            headerHeight: 0,
          }}
        />
      </>
    ),
    []
  );

  const [loading, setLoading] = React.useState(false);
  const [dataHash, setDataHash] = React.useState("");
  React.useEffect(() => {
    const currentDataHash = JSON.stringify(tableData);
    if (context.readyState === ComponentContextReadyState.Loading && !loading) {
      setLoading(true);
      setDataHash(currentDataHash);
    }

    if (context.readyState === ComponentContextReadyState.Loaded && loading && currentDataHash !== dataHash) {
      setLoading(false);
    }
  }, [tableData, context.readyState]);

  const setFragmentChildRef = (ref: HTMLDivElement | null) => {
    setFragmentChild(ref);
  };
  React.useEffect(() => {
    if (fragmentChil && window["exportMode"]) {
      const parent = fragmentChil.parentElement;
      if (parent) {
        parent.style.height = "auto";
        parent.style.minHeight = "auto";
      }
    }
  }, [fragmentChil]);

  if (!window["exportMode"] && (!tableData || loading || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  if (window["exportMode"]) {
    window["exportReady"] = tableData && context.readyState !== ComponentContextReadyState.Loading;
  }
  return (
    <>
      <ComponentTitle>AP Agriculture Terminal</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      {table}
      <ComponentFootnote>*Year in center is harvest year.{comments.length ? `**${comments.join(", ")}` : null}</ComponentFootnote>
      <div ref={setFragmentChildRef} style={{ height: 60 }}>
        {legend}
      </div>
    </>
  );
};
